import { axios, createFormData, handleError } from '../axios';

export const memberSendPasswordRecoveryCode = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post('member/account/forgotten/username', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
          reject();
        }
      })
      .catch((e) => {
        handleError(e);
        reject();
      });
  });
};
